<template>
      <div>
        <a href="https://t.me/btrworks" >
          <font-awesome-icon class="socialicon" :icon="['fab', 'telegram-plane']" size="2x"/> 
        </a>
        <a class="twitter-share-button"
                href="https://twitter.com/intent/tweet?text=Get%20Happiness&hashtags=btrworks&url=https://happy.btr.works"
                data-size="large">
              <font-awesome-icon  class="socialicon" :icon="['fab', 'twitter']" size="2x"/>
        </a>
        <a href="https://www.facebook.com/btrworkscom">
          <font-awesome-icon  class="socialicon" :icon="['fab', 'facebook']" size="2x"/>
        </a>
        <a href="https://www.youtube.com/channel/UCjdXiMBGTm0dVtEP_fim9Zw">
          <font-awesome-icon  class="socialicon" :icon="['fab', 'youtube']" size="2x"/>
        </a>
         <a href="https://plus.google.com/b/115066573036854573232/115066573036854573232">
          <font-awesome-icon  class="socialicon" :icon="['fab', 'google-plus-square']" size="2x"/>
        </a>
      </div>  
</template>

<script>

import Icon from 'vue-awesome/components/Icon'

export default {
  props: {},
  components: Icon,
  data: function () {
    return {
    }
  },
  computed: {
  },
  created () {},
  methods: {
  },
  mounted () {
  }
}
</script>

<style scoped>
a.nav-link {
  padding-top: 12px;
  color:grey;
}
.socialicon {
  margin: 10px;
  color: grey;
}
</style>




// WEBPACK FOOTER //
// src/components/btr-social.vue